__turbopack_context__.v({
  "cta": "CoreContactsGrid-module-scss-module__9qr2iW__cta",
  "description": "CoreContactsGrid-module-scss-module__9qr2iW__description",
  "list": "CoreContactsGrid-module-scss-module__9qr2iW__list",
});
